'use client'

import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'

export default async function goToLogin(router: AppRouterInstance) {
  const { push } = router
  push('/login', { scroll: false })
}
